<template>
  <div>
    <section class="section">
      <card-component
        class="has-table is-fullwidth"
        title="Role List"
        icon="account"
      >
        <template #headerRight>
          <router-link slot="right" to="role/create">
            <b-button
              v-if="hasPermission('POST')"
              type="is-primary"
              icon-left="plus"
              size="is-small"
            >
              Add Role
            </b-button>
          </router-link>
        </template>
        <fl-table
          is-paginated
          namespace="role"
          title-key="rolename"
          :columns="roleColumns"
          :has-update="hasPermission('PUT')"
          :has-delete="hasPermission('DELETE')"
          :service="service"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import { read as readRole, del as deleteRole } from '@/api/role'
import FlTable from '@/components/table/FlTable'

export default {
  name: 'ReadRole',
  components: { FlTable },
  data() {
    const roleColumns = [
      {
        label: 'Name',
        key: 'name'
      },
      {
        label: 'Permission',
        key: 'permissions',
        content: row => row.permissions.length
      }
    ]

    return {
      roleColumns,
      service: {
        read: readRole,
        delete: deleteRole
      }
    }
  },
  methods: {
    hasPermission(method) {
      return this.$store.getters['auth/hasPermission']('ROLE', method)
    }
  }
}
</script>
